import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-335ce270"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "handle material-icons" }, "drag_handle", -1))
const _hoisted_2 = {
  key: 0,
  class: "actions"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "content_paste", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "content_copy", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "edit", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons",
  style: {"margin":"-2px"}
}, "delete", -1))
const _hoisted_7 = {
  key: 1,
  class: "actions"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "check", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "close", -1))
const _hoisted_10 = {
  key: 2,
  class: "details"
}
const _hoisted_11 = { class: "save-version" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 3,
  class: "details"
}
const _hoisted_15 = {
  key: 4,
  class: "details error"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import Tooltip from "features/tooltips/Tooltip.vue";
import player from "game/player";
import { Direction } from "util/common";
import { computed, ref, toRefs, watch } from "vue";
import DangerButton from "./fields/DangerButton.vue";
import FeedbackButton from "./fields/FeedbackButton.vue";
import Text from "./fields/Text.vue";
import { LoadablePlayerData } from "./SavesManager.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    save: null
  },
  emits: ["export", "open", "duplicate", "delete", "editName"],
  setup(__props: any, { emit }: { emit: ({
    (e: "export"): void;
    (e: "open"): void;
    (e: "duplicate"): void;
    (e: "delete"): void;
    (e: "editName", name: string): void;
}), expose: any, slots: any, attrs: any }) {

const _props = __props as {
    save: LoadablePlayerData;
}


const { save } = toRefs(_props);


const dateFormat = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
});

const isEditing = ref(false);
const isConfirming = ref(false);
const newName = ref("");

watch(isEditing, () => (newName.value = save.value.name || ""));

const isActive = computed(() => save.value && save.value.id === player.id);
const currentTime = computed(() =>
    isActive.value ? player.time : (save.value && save.value.time) || 0
);

function changeName() {
    emit("editName", newName.value);
    isEditing.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["save", { active: _unref(isActive) }])
  }, [
    _hoisted_1,
    (!isEditing.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(save).error == undefined && !isConfirming.value)
            ? (_openBlock(), _createBlock(FeedbackButton, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('export'))),
                class: "button",
                left: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(Tooltip, {
                    display: "Export",
                    direction: _unref(Direction).Left,
                    class: "info"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["direction"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(save).error == undefined && !isConfirming.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('duplicate'))),
                class: "button"
              }, [
                _createVNode(Tooltip, {
                  display: "Duplicate",
                  direction: _unref(Direction).Left,
                  class: "info"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["direction"])
              ]))
            : _createCommentVNode("", true),
          (_unref(save).error == undefined && !isConfirming.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (isEditing.value = !isEditing.value)),
                class: "button"
              }, [
                _createVNode(Tooltip, {
                  display: "Edit Name",
                  direction: _unref(Direction).Left,
                  class: "info"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["direction"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(DangerButton, {
            disabled: _unref(isActive),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('delete'))),
            onConfirmingChanged: _cache[4] || (_cache[4] = value => (isConfirming.value = value))
          }, {
            default: _withCtx(() => [
              _createVNode(Tooltip, {
                display: "Delete",
                direction: _unref(Direction).Left,
                class: "info"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["direction"])
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("button", {
            onClick: changeName,
            class: "button"
          }, [
            _createVNode(Tooltip, {
              display: "Save",
              direction: _unref(Direction).Left,
              class: "info"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["direction"])
          ]),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (isEditing.value = !isEditing.value)),
            class: "button"
          }, [
            _createVNode(Tooltip, {
              display: "Cancel",
              direction: _unref(Direction).Left,
              class: "info"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["direction"])
          ])
        ])),
    (_unref(save).error == undefined && !isEditing.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "button open",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('open')))
          }, [
            _createElementVNode("h3", null, _toDisplayString(_unref(save).name), 1)
          ]),
          _createElementVNode("span", _hoisted_11, "v" + _toDisplayString(_unref(save).modVersion), 1),
          _hoisted_12,
          (_unref(currentTime))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Last played " + _toDisplayString(_unref(dateFormat).format(_unref(currentTime))), 1))
            : _createCommentVNode("", true)
        ]))
      : (_unref(save).error == undefined && isEditing.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(Text, {
              modelValue: newName.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newName).value = $event)),
              class: "editname",
              onSubmit: changeName
            }, null, 8, ["modelValue"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createTextVNode(" Error: Failed to load save with id " + _toDisplayString(_unref(save).id), 1),
            _hoisted_16,
            _createTextVNode(_toDisplayString(_unref(save).error), 1)
          ]))
  ], 2))
}
}

})